// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swap-message {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--black5);
}
.swap-select-dropdown {
  min-width: 270px;
  right: 0;
}
@media (max-width: 768px) {
  .swap-select-dropdown {
    min-width: unset;
  }
}
@media (max-width: 768px) {
  .swap-container {
    margin-bottom: 1rem;
  }
}
.swap-container .swap-item-img {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 0;
}
.swap-container .swap-item-img-info {
  display: flex;
  align-items: center;
  color: var(--black9);
}
.swap-container .swap-item-img-info > div {
  margin-left: 0.5rem;
}
.swap-container .swap-item-img.selected {
  background-color: var(--black1);
  color: var(--black9);
}
.swap-container .swap-item-img:hover {
  background-color: var(--black1);
  color: var(--black9);
}
@media (max-width: 768px) {
  .swap-container {
    width: 100%;
    display: flex;
  }
  .swap-container .swap-item-img {
    flex-direction: row-reverse;
    justify-content: space-between !important;
  }
  .swap-container .swap-item-img-info {
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
  }
  .swap-container .swap-item-img-info > div {
    margin-right: 0.5rem;
  }
}
.swap-message {
  color: var(--black4);
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 1rem;
}
.swap-switch {
  display: flex;
}
.swap-switch > label {
  margin-right: 1rem;
}
.swap-item {
  display: flex;
  justify-content: space-between;
  align-items: normal;
  position: relative;
}
@media (max-width: 768px) {
  .swap-item {
    flex-wrap: wrap;
    width: 100%;
  }
}
.swap-item-arrow {
  border-radius: 100%;
  border: 1px solid var(--black2);
  width: 2rem;
  height: 2rem;
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  transform: translate(-1rem, -1.5rem);
  top: 50%;
  background: var(--black0);
}
@media (max-width: 768px) {
  .swap-item-arrow {
    transform: translate(-1rem, -1.5rem);
  }
  .swap-item-arrow > svg {
    transform: rotate(90deg);
  }
}
.swap-item-from {
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
  border-radius: 0.5rem;
  padding: 1rem;
  justify-content: space-between;
  margin-bottom: 1rem;
  width: calc(50% - 0.5rem);
  cursor: pointer;
  border: 1px solid var(--black2);
  color: var(--black4);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
}
@media (max-width: 768px) {
  .swap-item-from {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}
.swap-item-from > div:first-child {
  margin-bottom: 0.5rem;
}
.swap-item-img {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  border-radius: 0.5rem;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black5);
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 0.75rem;
}
@media (max-width: 768px) {
  .swap-item-img {
    width: 100%;
  }
}
.swap-item-img.value {
  background: var(--black0);
  color: var(--black9);
}
.swap-item-img-chain {
  position: absolute;
  width: 0.75rem !important;
  height: 0.75rem !important;
  max-height: 0.75rem !important;
  min-height: 0.75rem !important;
  bottom: -4px;
  right: -3px;
  background: var(--black0);
  border-radius: 2px;
  padding: 1px;
}
.swap-item-img img {
  width: 1.25rem;
  height: 1.25rem;
  min-height: 1.25rem;
}
.swap-item-to {
  box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);
  border-radius: 0.5rem;
  padding: 1rem;
  justify-content: space-between;
  margin-bottom: 1rem;
  width: calc(50% - 0.5rem);
  cursor: pointer;
  border: 1px solid var(--black2);
  color: var(--black4);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
}
@media (max-width: 768px) {
  .swap-item-to {
    align-items: flex-start;
    width: 100%;
  }
}
.swap-item-to > div:first-child {
  margin-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/settings/shop/crypto/swaps/index.scss"],"names":[],"mappings":"AAEE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AADJ;AAKI;EACE,gBAAA;EACA,QAAA;AAHN;AAKM;EAJF;IAKI,gBAAA;EAFN;AACF;AAQI;EAFF;IAGI,mBAAA;EALJ;AACF;AAOI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;AALN;AAOM;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AALR;AAOQ;EACE,mBAAA;AALV;AASM;EACE,+BAAA;EACA,oBAAA;AAPR;AASM;EACE,+BAAA;EACA,oBAAA;AAPR;AAWI;EAhCF;IAiCI,WAAA;IACA,aAAA;EARJ;EAUI;IACE,2BAAA;IACA,yCAAA;EARN;EAUM;IACE,aAAA;IACA,8BAAA;IACA,2BAAA;EARR;EAUQ;IACE,oBAAA;EARV;AACF;AAcE;EACE,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAZJ;AAeE;EACE,aAAA;AAbJ;AAeI;EACE,kBAAA;AAbN;AAiBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAfJ;AAiBI;EANF;IAOI,eAAA;IACA,WAAA;EAdJ;AACF;AAgBI;EACE,mBAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;EACA,iFAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,oCAAA;EACA,QAAA;EACA,yBAAA;AAdN;AAgBM;EAfF;IAgBI,oCAAA;EAbN;EAeM;IACE,wBAAA;EAbR;AACF;AAiBI;EACE,iFAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,+BAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAhBN;AAkBM;EApBF;IAqBI,WAAA;IACA,qBAAA;EAfN;AACF;AAiBM;EACE,qBAAA;AAfR;AAmBI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EAEA,eAAA;EACA,2BAAA;EACA,YAAA;AAnBN;AAqBM;EAjBF;IAkBI,WAAA;EAlBN;AACF;AAoBM;EACE,yBAAA;EACA,oBAAA;AAlBR;AAqBM;EACE,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAnBR;AAsBM;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AApBR;AAwBI;EACE,iFAAA;EACA,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,+BAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAvBN;AA0BM;EArBF;IAsBI,uBAAA;IACA,WAAA;EAvBN;AACF;AA0BM;EACE,qBAAA;AAxBR","sourcesContent":[".swap {\n\n  &-message {\n    font-family: \"Inter\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    color: var(--black5);\n  }\n\n  &-select {\n    &-dropdown {\n      min-width: 270px;\n      right: 0;\n\n      @media (max-width: 768px) {\n        min-width: unset;\n      }\n    }\n  }\n\n  &-container {\n\n    @media (max-width: 768px) {\n      margin-bottom: 1rem;\n    }\n\n    .swap-item-img {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      margin-top: 0;\n\n      &-info {\n        display: flex;\n        align-items: center;\n        color: var(--black9);\n\n        & > div {\n          margin-left: .5rem;\n        }\n      }\n\n      &.selected {\n        background-color: var(--black1);\n        color: var(--black9);\n      }\n      &:hover {\n        background-color: var(--black1);\n        color: var(--black9);\n      }\n    }\n\n    @media (max-width: 768px) {\n      width: 100%;\n      display: flex;\n\n      .swap-item-img {\n        flex-direction: row-reverse;\n        justify-content: space-between !important;\n\n        &-info {\n          display: flex;\n          justify-content: space-between;\n          flex-direction: row-reverse;\n\n          & > div {\n            margin-right: .5rem;\n          }\n        }\n      }\n    }\n  }\n\n  &-message {\n    color: var(--black4);\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    margin-bottom: 1rem;\n  }\n\n  &-switch {\n    display: flex;\n\n    & > label {\n      margin-right: 1rem;\n    }\n  }\n\n  &-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: normal;\n    position: relative;\n\n    @media (max-width: 768px) {\n      flex-wrap: wrap;\n      width: 100%;\n    }\n\n    &-arrow {\n      border-radius: 100%;\n      border: 1px solid var(--black2);\n      width: 2rem;\n      height: 2rem;\n      box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: absolute;\n      left: 50%;\n      transform: translate(-1rem, -1.5rem);\n      top: 50%;\n      background: var(--black0);\n\n      @media (max-width: 768px) {\n        transform: translate(-1rem, -1.5rem);\n\n        & > svg {\n          transform: rotate(90deg);\n        }\n      }\n    }\n\n    &-from {\n      box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);\n      border-radius: .5rem;\n      padding: 1rem;\n      justify-content: space-between;\n      margin-bottom: 1rem;\n      width: calc(50% - 0.5rem);\n      cursor: pointer;\n      border: 1px solid var(--black2);\n      color: var(--black4);\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 13px;\n      line-height: 16px;\n\n      @media (max-width: 768px) {\n        width: 100%;\n        margin-bottom: .5rem;\n      }\n\n      & > div:first-child {\n        margin-bottom: .5rem;\n      }\n    }\n\n    &-img {\n      display: flex;\n      align-items: center;\n      padding: .5rem;\n      border-radius: .5rem;\n\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 17px;\n      color: var(--black5);\n\n      flex-wrap: wrap;\n      justify-content: flex-start;\n      gap: 0.75rem;\n\n      @media (max-width: 768px) {\n        width: 100%;\n      }\n\n      &.value {\n        background: var(--black0);\n        color: var(--black9);\n      }\n\n      &-chain {\n        position: absolute;\n        width: .75rem !important;\n        height: .75rem !important;\n        max-height: .75rem !important;\n        min-height: .75rem !important;\n        bottom: -4px;\n        right: -3px;\n        background: var(--black0);\n        border-radius: 2px;\n        padding: 1px;\n      }\n\n      img {\n        width: 1.25rem;\n        height: 1.25rem;\n        min-height: 1.25rem;\n      }\n    }\n\n    &-to {\n      box-shadow: 0 1px 3px rgba(7, 14, 35, 0.06), 0 2px 8px -1px rgba(7, 14, 35, 0.05);\n      border-radius: .5rem;\n      padding: 1rem;\n      justify-content: space-between;\n      margin-bottom: 1rem;\n      width: calc(50% - 0.5rem);\n      cursor: pointer;\n      border: 1px solid var(--black2);\n      color: var(--black4);\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 13px;\n      line-height: 16px;\n\n\n      @media (max-width: 768px) {\n        align-items: flex-start;\n        width: 100%;\n      }\n\n\n      & > div:first-child {\n        margin-bottom: .5rem;\n      }\n    }\n  }\n\n  &-container {\n\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
